// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a38976cd","239":"b151cd0b","455":"3a20bd24"}[chunkId] + ".chunk.js";
};